import {
    DateRange,
    IQueryString,
    LocationPickerSelection,
    objToQueryString
} from './';

export class GeneralFilter implements IQueryString {
    constructor(
        public date: DateRange,
        public locationsSelection?: LocationPickerSelection,
        public filter?: string) {}

    toQueryString() {
        let payload = {
            filter: this.filter
        };

        this.locationsSelection = this.locationsSelection || new LocationPickerSelection();

        return `${this.date.toQueryString()}&${this.locationsSelection.toQueryString()}&${objToQueryString(payload)}`;
    }

    clone() {

        let dr = new DateRange(this.date.start, this.date.end);
        let locationSelection = new LocationPickerSelection(
            this.locationsSelection.region,
            this.locationsSelection.locations);

        return new GeneralFilter(dr, locationSelection, this.filter);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/general-filter.ts